import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/UI/Button';
import { Home } from 'lucide-react';

export const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <div className="w-16 h-16 rounded-3xl bg-teal-50 dark:bg-teal-950 text-[#08707A] dark:text-teal-400 flex items-center justify-center font-black text-2xl shadow-lg mb-4">
        404
      </div>
      <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 tracking-tight">
        Página no encontrada
      </h1>
      <p className="text-xs text-slate-500 dark:text-slate-400 max-w-sm mt-1.5 mb-6">
        La página que estás intentando acceder no existe o fue movida a otra ubicación.
      </p>
      <Link to="/">
        <Button variant="primary" icon={Home} className="bg-[#08707A] hover:bg-[#065B63]">
          Volver al Inicio
        </Button>
      </Link>
    </div>
  );
};
